// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7470) return "wp-content/assets/js/pages/attraction/7470.js";
	// return url for filenames based on template
	return undefined;
};